import React from 'react';
import Button from '../../../components/ui/Button';


const SettingsTab = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-border bg-card">
      <div className="flex space-x-1 p-1">
        {tabs?.map((tab) => (
          <Button
            key={tab?.id}
            variant={activeTab === tab?.id ? "default" : "ghost"}
            onClick={() => onTabChange(tab?.id)}
            iconName={tab?.icon}
            iconPosition="left"
            iconSize={16}
            className="flex-1 justify-start"
          >
            {tab?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SettingsTab;